import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';
import { NamirasoftMap } from 'namirasoft-site-map';

interface SubscriberListPageProps extends NSARouterMakerResult, NotificationSenderProps { }

function SubscriberListPage(props: SubscriberListPageProps)
{
    let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

    return (
        <NotificationSenderLayout
            {...props}
            action={{
                description: "Display all Subscribers currently registered in your account. Each Subscriber is associated with a specific Topic and configured to deliver messages using a delivery channel."
            }}
            pages={{
                entity: NotificationSenderEntity.Subscriber(props),
                list: {
                    ui: {
                        search_box: {
                            exclude: {
                                load_value: (table, column) =>
                                {
                                    if (namirasoft.notification_sender.tables.sent_subscriber.name === table)
                                    {
                                        let columns = [
                                            namirasoft.notification_sender.tables.sent_subscriber.columns.message.name,
                                            namirasoft.notification_sender.tables.sent_subscriber.columns.result.name,
                                        ]
                                        return columns.includes(column);
                                    }
                                    return false;
                                }
                            }
                        }
                    }
                }
            }}
        >
            <></>
        </NotificationSenderLayout>
    );
}

export default SubscriberListPage;